import React, { Component } from "react";
import PropTypes from 'prop-types';
import classnames from 'classnames';

import "./Arrows.scss";

class Arrows extends Component {
  static propTypes = {
    sortUp: PropTypes.bool,
    sortDown: PropTypes.bool,
  };

  static defaultProps = {
    sortUp: false,
    sortDown: false,
  };

  render() {
    const { sortUp, sortDown } = this.props;

    const upClass = classnames({
      'up': true,
      'inactive': sortDown,
    });

    const downClass = classnames({
      'down': true,
      'inactive': sortUp,
    }); 

    return (
      <div className="arrows">
        <svg className={upClass} width="7" height="4" viewBox="0 0 7 4" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 3L3.5 1L6 3" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <svg className={downClass} width="7" height="4" viewBox="0 0 7 4" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L3.5 3L6 1" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    );
  }
}

export default Arrows;
